export enum HttpStatus {
    // Request is poorly formed
    BAD_REQUEST = 400,
    // The request was received but there are changes that conflict with the document
    CONCURRENTLY_MODIFIED = 550,
    // The document did exist but has been deleted
    CONCURRENTLY_DELETED = 551,
    // Invalid permissions
    FORBIDDEN = 403,
    // Generic server error indicating a processing issue occurred and  was not handled
    INTERNAL_SERVER_ERROR = 500,
    // Missing document
    NOT_FOUND = 404,
}
